import { RootState } from 'store/store';

export const selectRolesData = (state: RootState) => state.roles.roles;
export const selectRolesStatus = (state: RootState) => state.roles.rolesRequestStatus;
